import util from '@bmp-vue/core/api/util'

const controller = 'Groups'
export default Object.assign({}, util.GetCrud(controller, null), {
  GroupsPersist (key, dto) {
    if (!key) { return util.Axios.Post(`${controller}`, dto) } else { return util.Axios.Put(controller, key, dto) }
  }
})
